import WorkItemModalActions from '@/views/work-item/work-item-modal-actions.enum';
import WorkItemDefinitionType from '@/views/work-item/work-item-definition-type.enum';

export default class WorkItemModalState {
  createdDate = true;

  originCreatedDate = true;

  originSystem = true;

  deliveryDate = true;

  title: boolean;

  number = true;

  estimatedDeadLine: boolean;

  concludedAt: boolean;

  assignedTo: boolean;

  workItemType: boolean;

  isTask: boolean;

  status: boolean;

  parent: boolean;

  description: boolean;

  originalEstimate: boolean;

  storyPoints: boolean;

  effortSpent = true;

  buttonCancel: boolean;

  buttonSave: boolean;

  constructor(action: WorkItemModalActions, type: WorkItemDefinitionType) {
    this.title = action === WorkItemModalActions.VIEW
      || action === WorkItemModalActions.REACTIVATE;
    this.estimatedDeadLine = action === WorkItemModalActions.VIEW
      || action === WorkItemModalActions.REACTIVATE;
    this.concludedAt = action === WorkItemModalActions.VIEW
      || action === WorkItemModalActions.CREATE;
    this.assignedTo = action === WorkItemModalActions.VIEW
      || action === WorkItemModalActions.REACTIVATE;
    this.workItemType = action === WorkItemModalActions.VIEW
      || action === WorkItemModalActions.REACTIVATE
      || (action === WorkItemModalActions.CREATE && type === WorkItemDefinitionType.TASK);
    this.isTask = type === WorkItemDefinitionType.TASK;
    this.status = action === WorkItemModalActions.VIEW
      || action === WorkItemModalActions.CREATE;
    this.parent = action === WorkItemModalActions.VIEW
      || action === WorkItemModalActions.REACTIVATE;
    this.description = action === WorkItemModalActions.VIEW
      || action === WorkItemModalActions.REACTIVATE;
    this.originalEstimate = action === WorkItemModalActions.VIEW
      || action === WorkItemModalActions.REACTIVATE;
    this.storyPoints = action === WorkItemModalActions.VIEW
      || action === WorkItemModalActions.REACTIVATE;
    this.buttonCancel = action === WorkItemModalActions.VIEW;
    this.buttonSave = action === WorkItemModalActions.VIEW;
  }

  public static of(action: any, type: any): WorkItemModalState {
    return new WorkItemModalState(action, type || {});
  }

  public static ofVstsWorkItem(
    action: any,
    type: any,
  ): WorkItemModalState {
    const state = new WorkItemModalState(action, type);

    if (action !== WorkItemModalActions.VIEW) {
      state.title = false;
      state.description = false;
      state.workItemType = false;
      state.status = false;
      state.buttonSave = false;
      state.parent = WorkItemDefinitionType.TASK === type;
    }

    return state;
  }
}
